// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__eCvX4","feature":"Slider_feature__27e2e","mobile":"Slider_mobile__T5B_h","largeCard":"Slider_largeCard__rgeL8","rankCard":"Slider_rankCard__0_20A"};